import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button
} from 'reactstrap';

import {
  PageWrapper,
  PanelWrapper,
  PanelTopWrapper,
  TitlePage,
  SaveOrCancel,
  AlertMessage,
  ChangePassword
} from 'components';

import {
  InputValidation,
  PostUserService,
  MessageRequest,
  GetUniqueUserService,
  UpdateUserService,
  GetBasicBrandListService,
  UpdateUserPassword
} from 'services';

import * as yup from 'yup';

export const UsersDetail = () => {

  const URL_NEW_BRAND = "new";
  const PASSWORD_ERROR = "A senha deve ser a mesma em ambos os campos!";

  const populateObject = (invalid, message) => {
    return ({
      invalid,
      message
    })
  }
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [email, setEmail] = useState(populateObject(false, ''));
  const [name, setName] = useState(populateObject(false, ''));
  const [password, setPassword] = useState(populateObject(false, ''));
  const [newPassword, setNewPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");
  const [brand, setBrand] = useState(populateObject(false, ''));
  const [brandList, setBrandList] = useState([]);
  const [brandEdit, setBrandEdit] = useState([]);
  const [openChangePassword, setOpenChangePassword] = useState(false);

  let { topicId } = useParams();

  useEffect(() => {
    if (isdition()) {
      GetUniqueUserService(topicId).then((value) => {
        //TODO: Se não retornar os meus dados, redirecionar pra página de users
        if (!value) return;
        setName({ value: value?.name })
        setEmail({ value: value?.email })
        setPassword({ value: value?.password })
        setBrand({ value: value?.brand?.idBrand });
        setBrandEdit(value.brand);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicId]);

  useEffect(() => {
    GetBasicBrandListService().then((response) => {
      setBrandList(response)
    })
  }, [])

  const toggleChangePassword = () => {
    setOpenChangePassword(!openChangePassword);
  }

  const resetPassword = (password) => {
    UpdateUserPassword(
      {
        oldPassword: password?.currentPassword,
        newPassword: password?.password
      }).then(function (response) {
        MessageRequest("Senha atualizada", response, setMessage, setActive);
        toggleChangePassword();
      });
  }

  useEffect(() => {
    (newPassword === repeatedPassword && newPassword) ?
      setPassword({ value: newPassword }) : setPassword({ value: "" });
  }, [newPassword, repeatedPassword])

  const userSchema = yup.object().shape({
    password:
      yup.string()
        .required(),
    email:
      yup.string()
        .email()
        .required(),
    idBrand:
      yup.number()
        .required(),
    name:
      yup.string()
        .required()
  });

  const userFormData = {
    email: email.value,
    name: name.value,
    password: password.value,
    enabled: true,
    idBrand: brand.value
  }

  const toggle = (value) => {
    setActive(value);
  }

  const registerOrEdit = (url) => {
    !isdition() ? PostUserService(userFormData).then(function (response) {
      MessageRequest("Usuário cadastrado", response, setMessage, setActive);
    }) : UpdateUserService(url, userFormData).then(function (response) {
      MessageRequest("Usuario editado", response, setMessage, setActive);
    });
  }

  const getPopulateObject = (input, value) => {

    const inputs = {
      password: () => {
        setPassword(populateObject(true, PASSWORD_ERROR))
      },
      name: () => {
        setName(populateObject(true, value))
      },
      email: () => {
        setEmail(populateObject(true, value))
      },
      idBrand: () => {
        setBrand(populateObject(true, value));
      }
    }
    return inputs[input] ? inputs[input]() : registerOrEdit(topicId);
  }

  const getValidation = async () => {

    const feedback = await Promise.resolve(
      InputValidation({ schema: userSchema, formdata: userFormData })
    ).then(value => value);

    if (feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index]);
      });
    }

    return getPopulateObject(feedback?.id);
  }

  const renderOptionWithBrandList = (brandList) => {

    const brand = brandList ? brandList : [];
    return brand.map((brand, index) => {
      return (
        <option key={index} value={brand.idBrand}>
          {brand.name}
        </option>
      );
    });
  };

  const isdition = () => {
    return topicId === URL_NEW_BRAND ? false : true;
  }

  const renderPassword = () => {
    if (!isdition()) {
      return (
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="senha">
                Senha *
            </Label>
              <Input
                invalid={password.invalid}
                type="password"
                value={newPassword}
                id="senha"
                placeholder={'*******'}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }} />
              <FormFeedback>
                {password.message}
              </FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="repeatSenha">
                Confirme a senha *
           </Label>
              <Input
                invalid={password.invalid}
                type="password"
                value={repeatedPassword}
                id="repeatSenha"
                placeholder={'*******'}
                onChange={(e) => {
                  setRepeatedPassword(e.target.value);
                }} />
              <FormFeedback>
                {password.message}
              </FormFeedback>
            </FormGroup>
          </Col>
        </Row>
      )
    }
  }

  return (
    <PageWrapper>
      <PanelTopWrapper padding={"py-4"}>
        <TitlePage
          title={'Usuário'} />
      </PanelTopWrapper>
      <PanelWrapper>
        <Form>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="nome">
                  Nome *
                </Label>
                <Input
                  id="nome"
                  invalid={name.invalid}
                  value={name.value}
                  placeholder={'Ex: João Silva'}
                  onChange={(e) => setName({ value: e.target.value })} />
                <FormFeedback id="name"> {name.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="email">
                  E-mail *
                </Label>
                <Input
                  invalid={email.invalid}
                  type="email"
                  value={email.value}
                  id="email"
                  placeholder={'Ex: seuemail@mail.com'}
                  onChange={(e) => setEmail({ value: e.target.value })} />
                <FormFeedback id="email">{email.message} </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="selectMarcas">Marca *</Label>
                <Input
                  invalid={brand.invalid}
                  type="select"
                  name="select"
                  id="selectMarcas"
                  placeholder="Selecione"
                  value={brandEdit.idBrand}
                  onChange={(e) => {
                    setBrand({ value: e.target.value })
                    setBrandEdit({ idBrand: e.target.value })
                  }}
                >
                  <option value="">Selecione...</option>
                  {renderOptionWithBrandList(brandList)}
                </Input>
                <FormFeedback id="selectMarcas">{brand.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
          {renderPassword()}
        </Form>

        <SaveOrCancel
          actionCancel={'usuarios'}
          actionSave={getValidation} />
      </PanelWrapper>
      <Button onClick={toggleChangePassword} color="primary"> Alterar Senha  </Button>
      <AlertMessage message={message} active={active} toggle={toggle} />
      <ChangePassword visibility={openChangePassword} toggle={toggleChangePassword} save={resetPassword} />
    </PageWrapper >
  );
};
